import http from "./http.service";
import Promisable from "./promisable.service";
import { authActions } from "redux/slices/auth";
import { getAppDispatch } from "utils/dispatch.util";
import { bookingActions } from "./../redux/slices/booking";
import { MODAL, modalActions } from "redux/slices/modal";
import { NavigateFunction } from "react-router-dom";

const url = "/trip";

const BookingService = {
  verifyBooking: async (id: any) => {
    const [success, error]: any = await Promisable.asPromise(
      http.get(
        `/tripConfirmation?merchant_reference=${id}&is_verification=true&response_code=02000&service_command=VERIFICATION`
      )
    );
    return [success.data.data, error];
  },
  addBooking: async (data: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(bookingActions.setLoading(true));
    http.setJWT();
    http.acceptLanguage();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}`, data)
    );

    dispatch?.(bookingActions.setLoading(false));
    return [success, error];
  },



  updateBooking: async (id: string, data: any, token: string) => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();
    http.acceptLanguage();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/update/${id}`, data,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
    );
    if (success) {
      const { trip } = success.data.data;

      dispatch?.(modalActions.closeModal());
      dispatch?.(bookingActions.updateBooking(trip));
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },

  confirmBooking: async (data: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(bookingActions.setLoading(true));
    http.acceptLanguage();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/confirmtrip`, data)
    );

    dispatch?.(bookingActions.setLoading(false));
    return [success, error];
  },

  cancelBooking: async (id: any, token: string) => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));
    http.acceptLanguage();

    const [success, error]: any = await Promisable.asPromise(
      http.delete(`${url}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    );

    if (success) {
      const { trip, message, is_refund } = success.data.data;

      dispatch?.(modalActions.closeModal());

      if (trip) dispatch?.(bookingActions.updateBooking(trip));

      if (!is_refund)
        dispatch?.(
          modalActions.openModal({
            width: "400px",
            type: MODAL.CONFIRMATION_FORM,
            data: {
              id,
              message,
              type: MODAL.CONFIRM_CANCEL_BOOKING,
              heading: "Confirm Booking Cancellation",
              token
            },
          })
        );
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },

  confirmCancelBooking: async (id: any, token: string) => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));
    http.acceptLanguage();
    const [success, error]: any = await Promisable.asPromise(
      http.delete(`${url}/confirmcancel/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    );

    if (success) {
      const { trip } = success.data.data;

      if (trip) dispatch?.(bookingActions.updateBooking(trip));

      dispatch?.(modalActions.closeModal());
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },

  getAllBookings: async () => {
    const dispatch = getAppDispatch();
    dispatch?.(bookingActions.setLoading(true));

    http.setJWT();
    http.acceptLanguage();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}`)
    );

    if (success) {
      const { trips } = success.data.data;
      dispatch?.(bookingActions.setBookings(trips));
    }

    dispatch?.(bookingActions.setLoading(false));

    return [success, error];
  },

  getBookingPrices: async (data: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(bookingActions.setLoading(true));
    // console.log('enter on service', data);
    http.setJWT();
    http.acceptLanguage();
    // console.log('close to post api', data);
    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/getprices`, data)
    );
    // console.log("🚀 ~ error:", error)
    // console.log("🚀 ~ success:", success)
    dispatch?.(bookingActions.setLoading(false));
    return [success, error];
  },

  getBookingById: async (id: any, token: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(bookingActions.setLoading(true));

    http.setJWT();
    http.acceptLanguage();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/get/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
    );

    if (success) {
      const { trip } = success.data.data;
      dispatch?.(bookingActions.setBooking(trip));
    }

    dispatch?.(bookingActions.setLoading(false));

    return [success, error];
  },


  tripRating: async (data: any) => {
    const dispatch = getAppDispatch();

    http.setJWT();
    http.acceptLanguage();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/rating`, data)
    );

    if (success) dispatch?.(authActions.setUserTripRating(true));

    return [success, error];
  },

  confirmTip: async (data: any) => {
    http.setJWT();
    http.acceptLanguage();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/confirmTip`, data)
    );

    return [success, error];
  },

  reportProblem: async (token: string, id: string, data: any) => {
    const dispatch = getAppDispatch();
    http.setJWT();
    http.acceptLanguage();
    dispatch?.(modalActions.setLoading(true));

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/report/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    );

    if (success) {
      dispatch?.(modalActions.closeModal());
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },

  requestHistory: async (data: any) => {
    let payload: any = {};
    // const response = await fetch("https://geolocation-db.com/json/");
    // const res = await response.json();
    // payload.userID = data.user?._id;
    // payload.pickup = `${data.name} ${data.formatted_address}`;
    // payload.city = data.city;
    // payload.lat = data.geometry.location.lat;
    // payload.lng = data.geometry.location.lng;
    // payload.iP = res?.IPv4;
    // http.acceptLanguage();

    // const [success, error]: any = await Promisable.asPromise(
    //   http.post("/request-history", payload)
    // );
    // return [success, error];
  },

  bookingHistory: async (data: any) => {
    // let payload = { ...data };
    // let prices: any = [];
    // data?.classes &&
    //   data?.classes.forEach((element: any) => {
    //     prices.push({
    //       class: element.class_name,
    //       price: element.price_details.netto,
    //     });
    //   });
    // payload.prices = prices;
    // delete payload.classes;
    // const response = await fetch("https://geolocation-db.com/json/");
    // const res = await response.json();
    // payload.pickup = data.pickup;
    // payload.destination = data?.destination ? data?.destination : data?.hours;
    // payload.iP = res.IPv4;
    // http.acceptLanguage();

    // const [success, error]: any = await Promisable.asPromise(
    //   http.post("/request-history", payload)
    // );
    // return [success, error];
  },
};

export default BookingService;
